export default "/images/219e92b2affac95abd838aa689b6ad63.avif";